module.exports = __webpack_public_path__ + "static/the-widsith-f52ccbf283b18d8f49e2ab2d7a5ff28d.png";